import { UserListFilters } from '@hakimo-ui/hakimo/types';

export const UPDATE_FILTERS = 'UPDATE_FILTERS';
export const SET_PAGE = 'SET_PAGE';

export interface UpdateFiltersAction {
  type: typeof UPDATE_FILTERS;
  payload: UserListFilters;
}

export interface SetPageAction {
  type: typeof SET_PAGE;
  payload: number;
}

export type Action = UpdateFiltersAction | SetPageAction;
